import { ref, computed, onMounted } from 'vue'
import { isAvailableNow } from '@/utils/dates.js'

function filterTree (tree, now) {
  function filterNode (node) {
    const filteredChildren = []

    for (const child of node.children || []) {
      const filtered = filterNode(child)
      if (filtered) {
        filteredChildren.push(filtered)
      }
    }

    const selfAvailable = isAvailableNow(node, now)

    if (selfAvailable || filteredChildren.length > 0) {
      return {
        ...node,
        children: filteredChildren
      }
    }

    return null
  }

  const result = []

  for (const node of tree) {
    const filtered = filterNode(node)

    if (filtered) {
      result.push(filtered)
    }
  }

  return result
}

export default function (categoryTree) {
  const now = ref(null)

  const filteredTree = computed(() => {
    return now.value
      ? filterTree(categoryTree, now.value) // client
      : categoryTree // server
  })

  onMounted(() => {
    now.value = new Date()
  })

  return filteredTree
}
